import React from 'react'
import illustration from '../../../shared/assets/preparing-data-stub-illustration.svg'
import { StubContactLinks } from './StubContactLinks'

export const PreparingDataStub = () => {
  return (
    <div className={'flex justify-center'}>
      <div className={'flex w-full max-w-[320px] flex-col items-center gap-[24px]'}>
        <div className={'w-full'}>
          <img alt={'Illustration'} className={'mx-auto max-w-full'} src={illustration} />
        </div>
        <div className={'flex w-full flex-col gap-[16px]'}>
          <div className={'flex flex-col items-center'}>
            <h2 className={'text-center text-[24px]'}>Preparing your data...</h2>
          </div>
          <div className={'flex flex-col items-center'}>
            <p className={'text-center text-[15px] text-focus-500'}>
              Once it&apos;s ready you&apos;ll see an up-to-date report on affiliates, competitors
              and third parties on your branded SERP
            </p>
          </div>
        </div>
        <div className={'flex flex-col gap-[8px]'}>
          <p className={'text-center text-[15px] text-[#8E7CA7]'}>
            If you don’t see any data within 24 hours,
            <br />
            contact us
          </p>
          <StubContactLinks />
        </div>
      </div>
    </div>
  )
}
